import { Injectable } from "@angular/core";
import { VexLayoutService } from "@vex/services/vex-layout.service";
import { NavigationItem } from "./navigation-item.interface";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> =
    new BehaviorSubject<NavigationItem[]>([]);

  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor(private readonly layoutService: VexLayoutService) {
    this.loadNavigation();
  }

  loadNavigation(): void {
    this._items.next([
      {
        type: "link",
        label: "Dashboard",
        route: "/dashboard",
        routerLinkActiveOptions: { exact: true },
      },
      {
        type: "link",
        label: "Channels",
        route: "/channels",
        routerLinkActiveOptions: { exact: true },
      },
      {
        type: "link",
        label: "Posts",
        route: "/posts",
        routerLinkActiveOptions: { exact: true },
      },
      {
        type: "link",
        label: "API Docs",
        href: "https://documenter.getpostman.com/view/24364321/2sA3dygW15",
        routerLinkActiveOptions: { exact: true },
      },
    ]);
  }
}
